<div>
  <ng-container>
    <markdown [data]="content"></markdown>
  </ng-container>
</div>
